import { useDataChange } from 'Simple/Data'

/** @type {import('Simple/types.js').useDataOnChange} */
export default function useDataOnChange(props, data) {
  let change = useDataChange({
    context: 'tab',
    path: 'selected.filters',
    viewPath: props.viewPath,
  })

  return async function onChange(value) {
    change(value)
  }
}
